export default "__VITE_ASSET__CZHsnUQD__"